import type { ClaimRepairEntry } from './claimIntakeUtils';
import { getClaimRequests, requestHasLineItems } from './claimIntakeUtils';

/** True when any `requests[]` entry has at least one labor or part line. */
export function claimObjectHasPartAndLaborLines(claimObject: Record<string, unknown> | null | undefined): boolean {
  if (!claimObject) return false;
  return getClaimRequests(claimObject).some(requestHasLineItems);
}

/** Merge API claim_object with current 3Cs so score API sees latest intake edits. */
export function buildEnrichedClaimScoreFormState(
  claimObject: Record<string, unknown>,
  repairs: ClaimRepairEntry[],
  intakeExtras?: Record<string, unknown> | null
): Record<string, unknown> {
  return {
    ...(intakeExtras && Object.keys(intakeExtras).length > 0 ? intakeExtras : {}),
    ...claimObject,
    intake_repairs: repairs.map(({ id, complaint, cause, correction, labor_lines, part_lines }) => ({
      id,
      complaint,
      cause,
      correction,
      labor_lines,
      part_lines,
    })),
  };
}

export function stableStringifyForScoreKey(value: unknown): string {
  try {
    return JSON.stringify(value);
  } catch {
    return '[unserializable]';
  }
}
